/**
 * The sort the member currently has chosen in the Community feed.
 *
 * Deliberately module memory rather than localStorage: the choice is meant to
 * last for the visit and no longer. Leaving the feed resets it to the order
 * configured in the CRM, and so does relaunching the app.
 *
 * It lives outside React because the feed is not the only thing that reloads
 * it — the pull-to-refresh helper and the app-resume handler both rebuild page
 * one, and neither of them sits under the page that owns the state. Without a
 * shared answer they sent no `order_by` at all, which the API reads as "Nuovi
 * post": the list silently fell back to publication order while the selector
 * still said "Attività recente".
 */
let activeOrderBy = null;

export const setActiveCommunityFeedOrder = (orderBy) => {
  activeOrderBy = orderBy || null;
};

export const getActiveCommunityFeedOrder = () => activeOrderBy;

/** Leaving the feed — the next entry starts from the CRM default again. */
export const clearActiveCommunityFeedOrder = () => {
  activeOrderBy = null;
};
